export enum Position {
  start = 'start',
  center = 'center',
  end = 'end',
}
